import { snakeToCamel } from '../../../utils/object'

import Model from '../models'
import Evaluation from '@/services/evaluations'

import CommitmentAPI from './api'

export default class Commitment extends Model {
  static api = CommitmentAPI.create(Commitment)
  static readOnlyFields = ['id']

  static DIRECT_CONVERSATION = 'DIRECT_CONVERSATION'
  static INTRODUCTION_OFFER = 'INTRODUCTION'
  static RESOURCE_SUGGESTION = 'RESOURCE_SUGGESTION'

  constructor({
    id = null,
    name,
    evaluation = null,
    evaluationRef = {},
    description,
    status,
    includeInReport,
  } = {}) {
    super()
    Object.assign(this, {
      id,
      name,
      evaluation,
      evaluationRef,
      description,
      status,
      includeInReport,
    })
  }

  static create(opts = {}) {
    if (opts.evaluation_ref) {
      opts.evaluation_ref = opts.evaluation_ref.map(Evaluation.create)
    }
    return new Commitment(opts)
  }

  static fromAPI(json = {}) {
    const jsonCamel = snakeToCamel(json)
    //console.log("FromAPIBeforeEvalRefGathering")
    //console.log(jsonCamel)

    if (jsonCamel.evaluationRef) {
    //  console.log("inIf")
    ////  jsonCamel.evaluationRef = jsonCamel.evaluationRef.map(Evaluation.fromAPI)
    //  console.log("jsonCamel.evaluationRef")
    //  console.log(jsonCamel.evaluationRef)
    }
    return new Commitment(jsonCamel)
  }

  copy() {
    return new Commitment(this)
  }
}
